module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "order_toolbar toolbar pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('p', {
    staticClass: "goodslist1",
    staticStyle: {
      "margin": "0",
      "margin-left": "-22px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "31px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "-19px",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0px 12px"
    }
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "关键词语："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称/售后号/订单号/手机号"
    },
    model: {
      value: (_vm.filters.searchKey),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchKey", $$v)
      },
      expression: "filters.searchKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "10px"
    },
    attrs: {
      "label": "售后类型/状态："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.optionsType,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangeType
    },
    model: {
      value: (_vm.typeStatus),
      callback: function($$v) {
        _vm.typeStatus = $$v
      },
      expression: "typeStatus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "所属品牌商："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.optionsBrand,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.cityBrand),
      callback: function($$v) {
        _vm.cityBrand = $$v
      },
      expression: "cityBrand"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "display": "flex",
      "position": "relative"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "31.6%"
    },
    attrs: {
      "label": "提交时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%",
      "cursor": "pointer",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "title": _vm.value6,
      "editable": _vm.iseditable,
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1)]), _vm._v(" "), [_c('el-col', {
    staticClass: "order_content main_container",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("售后管理")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "售后单号",
      "align": "center",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.AsOrderNo,
            "label": scope.row.AsOrderNo
          }
        }, [_vm._v(_vm._s(scope.row.AsOrderNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "align": "center",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.OrderNo,
            "label": scope.row.OrderNo
          }
        }, [_vm._v(_vm._s(scope.row.OrderNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "售后类型",
      "align": "center",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.TypeName,
            "label": scope.row.TypeName
          }
        }, [_vm._v(_vm._s(scope.row.TypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.StatusName,
            "label": scope.row.StatusName
          }
        }, [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodsName,
            "label": scope.row.GoodsName
          }
        }, [_vm._v(_vm._s(scope.row.GoodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "售后原因",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Remark,
            "label": scope.row.Remark
          }
        }, [_vm._v(_vm._s(scope.row.Remark))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.SubmitTime,
            "label": scope.row.SubmitTime
          }
        }, [_vm._v(_vm._s(scope.row.SubmitTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "action_container",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.Id, scope.row.TypeName)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看\r\n                  ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "order_toolbar_footer",
    staticStyle: {
      "margin-top": "15px",
      "float": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-738674bf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/refund.vue
// module id = 1712
// module chunks = 3